import { render, staticRenderFns } from "./AdvancedSettingBox.vue?vue&type=template&id=6060fb1c&scoped=true"
import script from "./AdvancedSettingBox.vue?vue&type=script&lang=js"
export * from "./AdvancedSettingBox.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSettingBox.vue?vue&type=style&index=0&id=6060fb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060fb1c",
  null
  
)

export default component.exports